import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTabs,{staticClass:"pt-10"},[_c(VTab,{attrs:{"to":"/"}},[_vm._v(" Branch ")]),_c(VTab,{attrs:{"to":"/offer"}},[_vm._v("Offer")]),_c(VTab,{attrs:{"to":"/sharing-documents"}},[_vm._v("Sharing")]),_c(VTab,{attrs:{"to":"/validate"}},[_vm._v("Validate")]),_c(VTab,{attrs:{"to":"/sign"}},[_vm._v("Sign Documents")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }